import {
  Button,
  Icon,
  IconButton,
  MuiThemeProvider,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Grid,
} from '@material-ui/core';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { MyTablePagination } from 'components/MyTable/';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import Truncate from 'components/Truncate';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { editProductCampaign, listProductCampaigns } from 'store/Orbita/Product/actions';

import styles from './styles';

import type { ICheckoutsUrls } from '../..';
import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<{}> {
  type: 'producer' | 'affiliate' | 'eduzz' | 'my-links';
  classes?: any;
  listCampaigns: any;
  openUrlCreator: (campaign: string) => void;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openQuickView?: any;
  editProductCampaign: any;
  isProducer?: boolean;
  setUpdate: any;
  user: any;
  currentProduct: IProduct;
}

class CampaignTable extends Component<IProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      type: this.props.type,
      pagination: {
        current_page: 1,
        per_page: 15,
      },
      countResults: 0,
      lastCampaignUpdate: 0,
    };
  }

  // função para atualizar a lista de campanhas do produto
  updateListProducer = (idProduct: number, callback?: any) => {
    (async () => {
      try {
        await this.props.dispatch(listProductCampaigns(idProduct, this.state.pagination, {}, false, true, false));
        this.setState(
          {
            pagination: {
              current_page: this.props.listCampaigns ? this.props.listCampaigns.pagination.current_page : 1,
              per_page: this.props.listCampaigns ? this.props.listCampaigns.pagination.per_page : 15,
            },
            countResults: this.props.listCampaigns ? this.props.listCampaigns.pagination.total_items : 0,
          },
          () => {
            // scroll to element
            //document.getElementById('table__campaigns').scrollIntoView();

            if (callback && typeof callback == 'function') {
              callback();
            }
          }
        );
      } catch (error) {
        toast.error('Ops, erro na listagem das campanhas (produtor)');
      }
    })();
  };

  // função para atualizar a lista de campanhas dos afiliados
  updateListAffiliates = (idProduct: number, callback?: any) => {
    (async () => {
      try {
        await this.props.dispatch(listProductCampaigns(idProduct, this.state.pagination, {}, true, false, false));
        this.setState(
          {
            pagination: {
              current_page: this.props.listCampaigns ? this.props.listCampaigns.pagination.current_page : 1,
              per_page: this.props.listCampaigns ? this.props.listCampaigns.pagination.per_page : 15,
            },
            countResults: this.props.listCampaigns ? this.props.listCampaigns.pagination.total_items : 0,
          },
          () => {
            // scroll to element
            //document.getElementById('table__campaigns').scrollIntoView();

            if (callback && typeof callback == 'function') {
              callback();
            }
          }
        );
      } catch (error) {
        toast.error('Ops, erro na listagem das campanhas (afiliados)');
      }
    })();
  };

  // função para atualizar a lista de Links
  updateListMyLinks = (idProduct: number, callback?: any) => {
    (async () => {
      try {
        await this.props.dispatch(listProductCampaigns(idProduct, this.state.pagination, {}, false, false, true));
        this.setState(
          {
            pagination: {
              current_page: this.props.listCampaigns ? this.props.listCampaigns.pagination.current_page : 1,
              per_page: this.props.listCampaigns ? this.props.listCampaigns.pagination.per_page : 15,
            },
            countResults: this.props.listCampaigns ? this.props.listCampaigns.pagination.total_items : 0,
          },
          () => {
            // scroll to element
            //document.getElementById('table__campaigns').scrollIntoView();

            if (callback && typeof callback == 'function') {
              callback();
            }
          }
        );
      } catch (error) {
        toast.error('Ops, erro na listagem das campanhas (meus links)');
      }
    })();
  };

  // Altera o status da campanha
  handleChangeStatusCampaign = (idCampaign: number, status: boolean) => {
    (async () => {
      try {
        await this.props.dispatch(editProductCampaign(this.props.currentProduct.id, idCampaign, { active: status }));
        this.updateListOnTab();
        toast.success('Status atualizado com sucesso');
      } catch (error) {
        toast.error('Ops, erro na alteração de status');
      }
    })();
  };

  // função para atualizar a lista de acordo com a tab
  updateListOnTab = (callback?: any) => {
    switch (this.props.type) {
      case 'producer':
        this.updateListProducer(this.props.currentProduct.id, callback);
        break;
      case 'affiliate':
        this.updateListAffiliates(this.props.currentProduct.id, callback);
        break;
      case 'my-links':
        this.updateListMyLinks(this.props.currentProduct.id, callback);
        break;
      default:
        break;
    }
  };

  // alterar de página
  onChangePage = (event: any, page: number) => {
    const pagination = this.state.pagination;
    pagination.current_page = page + 1;

    this.setState(
      {
        pagination,
      },
      () => {
        this.updateListOnTab();
      }
    );
  };

  // altera a quantidade de itens por página
  onChangeRowsPerPage = (event: any) => {
    const pagination = this.state.pagination;
    pagination.per_page = event.target.value;

    this.setState(
      {
        pagination,
      },
      () => {
        this.updateListOnTab();
      }
    );
  };

  // ao clicar no status do afiliado
  handleClickStatusCampaignAffiliate = (idCampaign: number, status: string) => {
    (async () => {
      try {
        await this.props.dispatch(editProductCampaign(this.props.currentProduct.id, idCampaign, { status }));
        toast.success('Status atualizado com sucesso');
        this.updateListOnTab();
      } catch (error) {
        toast.error('Ops, erro na alteração de status do afiliado');
        this.setState({ lastCampaignUpdate: 0 });
      }
    })();
  };

  // component é montado
  async componentDidMount() {
    this.updateListOnTab();

    this.props.setUpdate(this.updateListOnTab);
  }

  // component recebe novos dados
  componentDidUpdate(prevProps: IProps) {
    if (this.props.currentProduct !== prevProps.currentProduct) {
      this.updateListOnTab();
    }
  }

  render() {
    const { classes, listCampaigns, editProductCampaign } = this.props;
    return (
      <div>
        <div>
          <Table>
            {this.props.type !== 'eduzz' && (
              <Fragment>
                <TableHead className={classes.head}>
                  <TableRow>
                    <TableCell className={classes.cell}>Status</TableCell>
                    <TableCell className={classes.cell}>Chave</TableCell>
                    <TableCell className={classes.cell}>FI</TableCell>
                    <TableCell className={classes.cell}>Campanha</TableCell>
                    <TableCell className={classes.cell}>URL divulgação</TableCell>
                    <TableCell className={classes.cell} align='right'>
                      RPC/A
                    </TableCell>
                    <TableCell className={classes.cell} align='right'>
                      RPC/P
                    </TableCell>
                    <TableCell className={classes.cell} align='right'></TableCell>
                  </TableRow>
                </TableHead>

                {(this.props.type === 'producer' || this.props.type === 'affiliate' || this.props.type === 'my-links') && (
                  <TableBody>
                    {((listCampaigns && listCampaigns.isFetching) || (editProductCampaign && editProductCampaign.isFetching)) && (
                      <TableRow style={{ textAlign: 'center' }}>
                        <TableCell colSpan={8}>
                          <Spin />
                        </TableCell>
                      </TableRow>
                    )}

                    {listCampaigns &&
                      !listCampaigns.isFetching &&
                      editProductCampaign &&
                      !editProductCampaign.isFetching &&
                      listCampaigns.data &&
                      listCampaigns.data.length > 0 &&
                      listCampaigns.data.map((item: any) => {
                        return (
                          <TableRow key={'cpg' + item.id} id={'campaign-' + item.id} className='campaign-row' style={{ backgroundColor: '#ffffff' }}>
                            <TableCell className={classes.cell} colSpan={1}>
                              <Tooltip title={item.active ? 'Ativo' : 'Inativo'} placement='top'>
                                <div>
                                  <Switch
                                    checked={item.active}
                                    color='default'
                                    onClick={() => this.handleChangeStatusCampaign(item.id, item.active ? false : true)}
                                    disabled={this.props.type === 'affiliate' || (this.props.type === 'producer' && !this.props.isProducer)}
                                  />
                                </div>
                              </Tooltip>
                              {this.props.type === 'my-links' && item.status === 'R' && (
                                <Tooltip
                                  placement='top'
                                  // eslint-disable-next-line max-len
                                  title='Essa campanha foi reprovada pelo produtor e o redirecionamento será feito para a página de venda padrão da Eduzz'
                                >
                                  <Icon style={{ fontSize: 16, marginLeft: '0.5rem', color: 'red' }}>warning</Icon>
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell className={classes.cell}>{item.key}</TableCell>
                            <TableCell className={classes.cell}>
                              {item.infinity_funnel ? (
                                <Tooltip placement='top' title='Verificado'>
                                  <div style={{ display: 'block' }}>
                                    <img style={{ width: 24 }} src='/img/icon_funil_ativo.png' alt='Funil' />
                                  </div>
                                </Tooltip>
                              ) : (
                                <Tooltip placement='top' title='Não verificado'>
                                  <div style={{ display: 'block' }}>
                                    <img style={{ width: 24 }} src='/img/icon_funil.png' alt='Funil' />{' '}
                                  </div>
                                </Tooltip>
                              )}
                            </TableCell>
                            <TableCell className={classes.cell}>
                              <Truncate count='25' final='...'>
                                {item.title}
                              </Truncate>
                            </TableCell>
                            <TableCell className={classes.cell}>
                              <Grid container spacing={2} justify={'flex-start'} alignItems={'center'}>
                                <Grid item xs={6}>
                                  <CustomCopyToClipboard disableUnderline text={`https://edzz.la/${item.key}?a=${localStorage.getItem('id')}`} />
                                </Grid>
                                <Grid item xs={6}>
                                  <PermissionHide action='myeduzz:links:editar'>
                                    <Button
                                      onClick={() => {
                                        this.props.openUrlCreator(`https://edzz.la/${item.key}?a=${localStorage.getItem('id')}`);
                                      }}
                                      variant='outlined'
                                    >
                                      <Icon style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }}>edit</Icon>
                                      Criador de URL
                                    </Button>
                                  </PermissionHide>
                                </Grid>
                                <Grid item xs={12}>
                                  <div className={classes.bt_help}>
                                    <Truncate
                                      count='512'
                                      final='...'
                                      after={
                                        <Fragment>
                                          {!item.valid_url && item.url.length > 0 && (
                                            <Tooltip
                                              placement='bottom'
                                              // eslint-disable-next-line max-len
                                              title='Essa URL não possui script de rastreio validado pela Eduzz. Utilize a URL acima para garantir o ganho de comissões.'
                                            >
                                              <Icon className={classes.bt_help} style={{ fontSize: 12, marginLeft: '0.5rem' }}>
                                                help
                                              </Icon>
                                            </Tooltip>
                                          )}
                                        </Fragment>
                                      }
                                    >
                                      {`${item.url}?a=${localStorage.getItem('id')}`}
                                    </Truncate>
                                  </div>
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell className={classes.cell} align='right'>
                              {item.rpc_affiliate}
                            </TableCell>
                            <TableCell className={classes.cell} align='right'>
                              {item.rpc_producer}
                            </TableCell>

                            {(this.props.type === 'producer' || this.props.type === 'my-links') && (
                              <TableCell className={classes.cell} align='right'>
                                {(this.props.type === 'producer' || this.props.type === 'my-links') && (
                                  <IconButton
                                    onClick={() => {
                                      this.props.openQuickView(item);
                                    }}
                                  >
                                    <Icon style={{ fontSize: 20 }}>more_horiz</Icon>
                                  </IconButton>
                                )}
                              </TableCell>
                            )}

                            {/* affiliate campanha ativa */}
                            {item.can_moderate && this.props.type === 'affiliate' && item.status === 'A' && (
                              <TableCell className={classes.cell2} align='right'>
                                <Button
                                  size='small'
                                  style={{ left: 0, backgroundColor: '#009358', color: 'white', cursor: 'no-drop' }}
                                  className={classes.bt_approve}
                                  disabled={true}
                                >
                                  <Icon>thumb_up</Icon>
                                </Button>

                                <Button
                                  size='small'
                                  className={classes.bt_disapprove}
                                  style={{ right: 0 }}
                                  onClick={() => this.handleClickStatusCampaignAffiliate(item.id, 'R')}
                                >
                                  <Icon>thumb_down</Icon>
                                </Button>
                              </TableCell>
                            )}

                            {/* affilate campanha desativada */}
                            {item.can_moderate && this.props.type === 'affiliate' && item.status === 'R' && (
                              <TableCell className={classes.cell2} align='right'>
                                <Button
                                  size='small'
                                  style={{ left: 0 }}
                                  className={classes.bt_approve}
                                  onClick={() => this.handleClickStatusCampaignAffiliate(item.id, 'A')}
                                >
                                  <Icon>thumb_up</Icon>
                                </Button>

                                <Button
                                  size='small'
                                  className={classes.bt_disapprove}
                                  style={{ right: 0, backgroundColor: '#DC3F53', color: 'white', cursor: 'no-drop' }}
                                  disabled={true}
                                >
                                  <Icon>thumb_down</Icon>
                                </Button>
                              </TableCell>
                            )}

                            {/* affiliate campanha pendente */}
                            {item.can_moderate && this.props.type === 'affiliate' && (item.status === 'P' || item.status === null) && (
                              <TableCell className={classes.cell2} align='right'>
                                <Button
                                  size='small'
                                  style={{ left: 0 }}
                                  className={classes.bt_approve}
                                  onClick={() => this.handleClickStatusCampaignAffiliate(item.id, 'A')}
                                >
                                  <Icon>thumb_up</Icon>
                                </Button>

                                <Button
                                  size='small'
                                  className={classes.bt_disapprove}
                                  style={{ right: 0 }}
                                  onClick={() => this.handleClickStatusCampaignAffiliate(item.id, 'R')}
                                >
                                  <Icon>thumb_down</Icon>
                                </Button>
                              </TableCell>
                            )}
                            {this.props.type === 'affiliate' && !item.can_moderate && <TableCell className={classes.cell2} align='right'></TableCell>}
                          </TableRow>
                        );
                      })}

                    {listCampaigns && !listCampaigns.isFetching && listCampaigns.data && listCampaigns.data.length === 0 && (
                      <TableRow style={{ textAlign: 'center', backgroundColor: '#ffffff' }}>
                        <TableCell colSpan={8}>Nenhuma campanha encontrada</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Fragment>
            )}
          </Table>
          <div style={{ padding: '24px' }}>
            <MuiThemeProvider theme={theme}>
              <MyTablePagination
                count={this.state.countResults}
                page={this.state.pagination.current_page - 1}
                rowsPerPageOptions={[15, 25, 35, 50]}
                rowsPerPage={this.state.pagination.per_page}
                onPageChange={this.onChangePage}
                labelDisplayedRows={({ from, to, count }: any) => `${from}-${to} de ${count}`}
                labelRowsPerPage='Itens por página:'
                onChangeRowsPerPage={this.onChangeRowsPerPage}
              />
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listCampaigns: state.orbita.Product.productCampaigns,
    editProductCampaign: state.orbita.Product.editProductCampaign,
    currentProduct: state.orbita.Product.product,
    user: state.orbita.User.user,
  };
}

export default styles(connect(mapStateToProps)(CampaignTable)) as any;
